module.exports = __webpack_public_path__ + "static/media/animated_logo.52e0714e.svg";